import classNames from "classnames";
import React, { type TextareaHTMLAttributes, useEffect, useRef } from "react";

interface ITextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  as?: "default";
  isError?: boolean;
  className?: string;
}

export default function TextArea({ id, isError = false, placeholder, className, value, defaultValue, ...props }: ITextAreaProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  const handleResizeHeight = () => {
    if (!ref.current) return;
    ref.current.style.height = "auto"; // height 초기화
    ref.current.style.height = `${ref.current.scrollHeight}px`;
  };

  useEffect(() => {
    handleResizeHeight();
  }, [value, defaultValue]); // 값이 변경되거나 초기 할당될 때도 높이 재계산

  return (
    <textarea
      className={classNames(
        [
          "placeholder:text-grey resize-none overflow-hidden border-b-[0.5px] border-solid border-black py-2.5 outline-hidden",
          isError && "border-red",
        ],
        className,
      )}
      defaultValue={defaultValue}
      id={id}
      onInput={handleResizeHeight}
      placeholder={placeholder}
      ref={ref}
      rows={1}
      value={value}
      {...props}
    />
  );
}
